<template>
  <div>LayoutBM</div>
</template>

<script>
export default {
  name: 'Modul',
  props: {
    route: {
      type: Object,
      default: () => ({}),
    },
    context: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
